import { CarouselSlide } from '@/components/schools/Carousel/types';

export const slides: CarouselSlide[] = [
	{
		authorHandle: '@msdalyLST',
		authorName: 'Lauren Daly Clark',
		authorImage: '/_n/images/schools/lauren-photo.webp',
		storyImage: '/_n/images/schools/lauren-tweet-attachment.webp',
		copy: 'When given a choice today, this kiddo wanted to hear more from @KingJames himself on “managing emotions”. Thank you @calm for opening this door for us. This was truly a special moment today ❤️✨',
	},
	{
		authorHandle: '@MissEEpstein',
		authorName: 'Miss Epstein',
		authorImage: '/_n/images/schools/eepstein-photo.webp',
		copy: 'I often use @calm during writing sessions at school. There are lots of relaxing instrumentals that help my children to focus (they also know that if I can’t hear my music, they’re too loud). They love it. Today I’m using it as relaxing background noise whilst reading. 😌',
	},

	{
		authorHandle: '@Hilton32164',
		authorName: 'Mrs. Hilton',
		authorImage: '/_n/images/schools/hilton-photo.webp',
		copy: "Feeling stressed or anxious?  I encourage you to take time to breathe and meditate. @calm is a wonderful resource that I've used by myself and with students for years. Free for educators. #meditate",
	},
];
